import { TimePeriodDropdown } from "@/components/TimePeriod/TimeRangeDropdown";
import { STRUCTURE_TIME_PERIODS, StructureTimePeriodsValue } from "@/config/date";
import { DeactivatedBadge } from "@/components/badges/DeactivatedBadge";
import { DateRange } from "react-day-picker";

type StructureHeaderProps = {
	structure: Dryp.Structure;
	timePeriod: StructureTimePeriodsValue;
	onTimePeriodChange: (value: StructureTimePeriodsValue, range: DateRange | undefined) => void;
};

export const StructureHeader = ({ structure, timePeriod, onTimePeriodChange }: StructureHeaderProps) => {
	const description = structure.description;

	return (
		<header className="sticky top-0 z-50 bg-card/50 backdrop-blur-sm border-b border-border">
			<div className="px-6 py-3">
				<div className="flex items-center justify-between">
					<div>
						<div className="flex items-center gap-2">
							<h1 className="text-lg font-semibold">{structure.name}</h1>
							{!structure.isActive && <DeactivatedBadge />}
						</div>
						<div className="flex items-center gap-2 text-xs text-muted-foreground mt-0.5">
							<span>{description}</span>
						</div>
					</div>
					<div className="flex items-center">
						<TimePeriodDropdown
							value={timePeriod}
							onChange={onTimePeriodChange}
							options={STRUCTURE_TIME_PERIODS}
							showLabel={false}
							className="h-8"
						/>
					</div>
				</div>
			</div>
		</header>
	);
};
